module.exports = __webpack_public_path__ + "img/seaPalace-1.eb133644.jpg";